export default "__VITE_ASSET__BHQA33J5__"